<template>

  <div>

    <Row type="flex" align="middle" justify="space-between" class="mb-50">
      <Col :xs='24' :sm='24' :md="0" class="mb-10">
        <h2>
          Итоговая сумма: <span>{{total}}</span>
        </h2>
      </Col>

      <Row type="flex" :gutter="24">
        <Col class="mb-10" :xs='24' :sm='0'>
          <Button style="width: 100%;" type="info" @click="paymentType('count')">Оплата со счета</Button>
          <Modal
            footer-hide="true"
            v-model="modalCount"
            title="">
            <h3 class="mb-40">Информация по счету</h3>

            <p class="fs-16 mb-30">Счет на оплату успешно создан! Чтобы скачать файл, <a id="countLink" style="white-space: nowrap; color: #5296f0; text-decoration: underline">нажмите на ссылку</a></p>

            <Row type="flex" justify="end">
              <Button type="error" @click="modalCount = false">Закрыть</Button>
            </Row>
          </Modal>
        </Col>

        <Col class="mb-10" :xs='24' :sm='0'>
          <Button style="width: 100%;" type="info" @click="paymentType('card')">Оплата картой</Button>
          <Modal
            footer-hide="true"
            v-model="modalCard"
            title="">
            <h3 class="mb-40">Информация по счету</h3>

            <p class="fs-16 mb-30">
              Счет для оплаты банковской картой успешно создан. <br>
              Для перехода к оплате нажмите кнопку <span class="font-bold">"оплатить"</span>.
            </p>

            <Row type="flex" justify="end">
              <Button type="info" @click="paymentByCard(ecom.url, ecom.orderId, ecom.password)">Оплатить</Button>
            </Row>
          </Modal>
        </Col>

        <Col class="mb-10" :xs='24' :sm='0'>
          <Button  style="width: 100%;" type="info" @click="paymentType('qiwi')">Оплата через QIWI</Button>
          <Modal
            footer-hide="true"
            v-model="modalQiwi"
            title="">
            <h3 class="mb-40">Информация по счету</h3>

            <h5 class="mb-15">Инструкция по оплате через терминалы Qiwi:</h5>

            <p class="fs-15"><span class="font-bold">шаг 1.</span> На главном экране терминала нажмите на "Оплата услуг".</p>
            <p class="fs-15"><span class="font-bold">шаг 2.</span> Далее нажмите на "Другие услуги".</p>
            <p class="fs-15"><span class="font-bold">шаг 3.</span> Найдите в списке "Light Kassa", нажмите.</p>
            <p class="fs-15"><span class="font-bold">шаг 4.</span> Внесите номер сформированного счета - <span class="font-bold">{{currentCount}}</span>.</p>
            <p class="fs-15 mb-40"><span class="font-bold">шаг 5.</span> Внесите сумму согласно сформированному счету - <span class="font-bold">{{currentCount}}</span>.</p>

            <Row type="flex" justify="end">
              <Button type="error" @click="modalQiwi = false">Закрыть</Button>
            </Row>
          </Modal>
        </Col>
      </Row>

    </Row>


    <Row>
      <!--CHECK ALL FOR MOBILE-->
      <Col span="24" class="checkAllMobile">

        <Checkbox
          label="Выбрать все кассы"
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="handleCheckAll">
          <span>Выбрать все кассы</span>
        </Checkbox>

      </Col>
    </Row>


    <Row type="flex" class="color-grey fs-15 mb-30 header-row">
      <Col span="1" style="padding-left: 15px">
        <Checkbox
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="handleCheckAll"></Checkbox>

        <!--Modal for Check ALL Cash-->
        <Modal
          footer-hide="true"
          v-model="modalCheckAll"
          title="">
          <h3 class="mb-40">Хотите выбрать единый тариф для всех касс?</h3>

          <Select label="Выберите тариф" v-model="checkAllTariffModel" class="mb-40">
            <Option v-for="option in tariffs"
                    :key="option.tariffId"
                    :value="option.tariffId"
            >
              {{option.name}}
            </Option>
          </Select>
          <Row type="flex" justify="center">
            <Button type="info" style="margin-right: 12px"
                    :disabled = !checkAllTariffModel
                    @click="checkAllTariff">
              ДА
            </Button>
            <Button type="error" @click="modalCheckAll = false">НЕТ</Button>
          </Row>
        </Modal>

      </Col>


      <Col :sm="24" :lg='4' :xl="4" :xxl="5">Наименование кассы</Col>
      <Col span="4" style="text-align: center">Точка продаж</Col>
      <Col span="3" style="text-align: center">Заводской номер</Col>
      <Col span="3" style="text-align: center">Cтатус кассы</Col>
      <Col span="3" style="text-align: center">Дата окончания срока подписки</Col>
      <Col :lg='4'  :xl="4" :xxl="3" style="text-align: center">Выберите тариф</Col>
      <Col span="2" style="text-align: right; padding-right: 15px">Итого</Col>
    </Row>

    <Row type="flex" align="middle" v-for="item in data" class="card-container body-row mb-10">
      <Col :xs="2"  :sm='2' :lg="1" class="input-box">
        <input type="checkbox" v-model="selected" :value="item">
      </Col>
      <Col :xs="22" :sm="22" :lg='4'  :xl="4" :xxl="5" class="title">{{item.name}}</Col>
      <Col :xs="24" :sm="24"  :lg="4" class="text-center main-info"> <span class="title-box">Точка продаж</span> {{item.point.name}}</Col>
      <Col :xs="24" :sm="24"  :lg="3" class="text-center main-info"> <span class="title-box">Заводской номер</span> {{item.manufacturerNumber}}</Col>
      <Col :xs="24" :sm="24"  :lg="3" class="text-center main-info"><span class="title-box">Статус кассы</span> {{item.status}}</Col>
      <Col :xs="24" :sm="24"  :lg="3" class="text-center main-info"><span class="title-box">Дата окончания срока подписки</span> {{item.expirationDate}}</Col>
      <Col :xs="24" :sm="24" :lg='4' :xl="4" :xxl="3" class="text-center select-box">
        <Select label="Выберите тариф" v-model="item.selectedTariffs" style="max-width: 200px">
          <Option v-for="option in tariffs"
                  :key="option.tariffId"
                  :value="option.tariffId"
                  >
            {{option.name}}
          </Option>
        </Select>
      </Col>
      <Col :xs='24' :sm="24" :lg="2" class="text-right">
        <span class="title-box">Итого: </span>
        <span class="font-bold" v-if="item.selectedTariffs && el.tariffId === item.selectedTariffs" v-for="el in tariffs">
          {{el.price}}
        </span>

        <span v-if="!item.selectedTariffs">
          0
        </span>
      </Col>
    </Row>


    <p style="margin-top: 30px">
      Итоговая сумма: <span class="font-bold">{{total}}</span>
    </p>
  </div>
</template>

<script>

    import {server_addr} from "../../http";
    import {base_url} from "../../http";



    export default {
        data() {
            return {
                loading: true,
                data: [],
                tariffs: [],
                selected: [],
                commonPrice: 0,
                tariffPrice: '',

                indeterminate: false,
                checkAll: false,
                modalCheckAll: false,
                checkAllTariffModel: '',

                modalQiwi: false,
                modalCard: false,
                modalCount: false,

                currentCount: '',

                ecom: {
                    orderId: '',
                    sessionId: '',
                    password: '',
                    status: '',
                    url: ''
                }
            };
        },

        computed: {
            total(){
                let total = 0;
                this.selected.forEach(item => {
                  let tariff_id = item.selectedTariffs;

                  this.tariffs.forEach(tariff => {
                      if(tariff.tariffId === tariff_id)
                          total += tariff.price
                  })

                });
                return total;
            }
        },

        // Загружаем данные для таблицы
        methods: {
            fetchData: function () {
                this.loading = true;
                let url = base_url + "/proxy/cashboxes/";
                this.$http
                    .get(url)
                    .then(result => {
                        result.data.forEach(item => item.selectedTariffs = '');
                        this.data = result.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getTariffs: function () {
                this.loading = true;
                let url = server_addr + "/proxy_/billing/v1/tariffs/";
                this.$http
                    .get(url, {
                        params: {
                            showOrg: false
                        }
                    })
                    .then(result => {
                        this.tariffs = result.data.list;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getPageParams: function() {
                const fullyPaidStatus = 'fullypaid'
                const preparingStatus = 'preparing'
                const expiredStatus = 'expired'
                const voidedStatus = 'voided'
                const partPaidStatus = 'partpaid'
                const refundedStatus = 'refunded'
                const declinedStatus = 'declined'
                const cancelledStatus = 'cancelled'
                const authorizedStatus = 'authorized'
                const rejectedStatus = 'rejected'
                const closedStatus = 'closed'
                const refusedStatus = 'refused'

                const urlParams = new URLSearchParams(window.location.search);
                const paymentStatus = urlParams.get('STATUS');

                if (paymentStatus) {
                  const status = paymentStatus.toLowerCase() 
                  
                  switch (status) {
                      case fullyPaidStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Оплата произведена успешно.'
                          });
                          break;

                      case declinedStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Оплата отклонена банком эмитентом или эквайером.'
                          });
                          break;
                      
                      case cancelledStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Заказ отменен клиентом до оплаты.'
                          });
                          break;

                      case refusedStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Заказ отменен клиентом до оплаты или после неудачной попытки оплаты.'
                          });
                          break;

                      case rejectedStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Операция отвергнута.'
                          });
                          break;

                      case closedStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Заказ закрыт после оплаты.'
                          });
                          break;
                      
                      case preparingStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Оплата подготавливается.'
                          });
                          break;

                      case expiredStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Истек срок действия заказа.'
                          });
                          break;

                      case voidedStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Оплата аннулирована.'
                          });
                          break;

                      case partPaidStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Совершена частичная оплата.'
                          });
                          break;

                      case refundedStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Оплата возвращена.'
                          });
                          break;

                      case authorizedStatus:
                          this.$Notice.open({
                              title: 'Уведомление',
                              desc: 'Авторизация завершена.'
                          });
                          break;

                      default:
                          this.$Notice.open({
                                  title: 'Уведомление',
                                  desc: 'Неизвестный статус платежа.'
                          });
                          break;
                        }

                    history.replaceState({}, document.title, window.location.pathname);
                }
            },

            //Отмечаем все кассы
            handleCheckAll () {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;

                if (this.checkAll) {
                    this.modalCheckAll = true;
                    this.selected = this.data;

                } else {
                    this.selected = [];
                }
            },

            //Выбираем ОДИН тариф для всех касс
            checkAllTariff () {
                this.selected.forEach(tariff => {
                    tariff.selectedTariffs = this.checkAllTariffModel
                });

                this.modalCheckAll = false
            },


            //Формируем оплату
            paymentType(type) {
                let postPayment = [];
                this.selected.forEach(cash => {
                    postPayment.push(new Object({cashboxId: cash.cashId, tariffId: cash.selectedTariffs}))
                });

                //Проверяем отмечена ли касса
                if(this.selected.length === 0) {
                    return this.$Notice.open({
                        title: 'Уведомление',
                        desc: 'Для оплаты выберите хотя бы одну кассу.'
                    });
                }

                if(this.selected) {
                    let noerror = true;
                    this.selected.forEach(item => {

                        //Проверяем выбран ли тариф
                        if(item.selectedTariffs === '') {
                            noerror = false;
                        }
                    });

                    if(!noerror) {
                        this.$Notice.open({
                            title: 'Уведомление',
                            desc: 'Выберите тариф для всех отмеченных касс.'
                        });
                    }


                    /* ОПЛАТА СО СЧЕТА */
                    if(noerror && type === 'count') {
                        const url = server_addr + "/proxy_/billing/v1/bills";
                        let urlPay;
                        this.$http
                            .post(url, {
                                "paymentMethod": "ORDER",
                                "items": postPayment
                            })
                            .then(response => {
                                urlPay = server_addr + "/proxy_/billing/v1/bills/" + response.data.billId + "/payment";
                                this.$http
                                  ({
                                      header: {
                                          'Content-type': 'application/pdf',
                                      },
                                      method: "get",
                                      url: urlPay,
                                      responseType: "blob"
                                  })

                                    .then(response => {
                                        this.loading = true;
                                        const blob = new Blob([response.data], { type:"application/pdf" });
                                        let link = document.getElementById('countLink');
                                        link.href = URL.createObjectURL(blob);
                                        link.download = 'payment.pdf';
                                        window.URL.revokeObjectURL(url);
                                        // link.click()

                                    })
                                    .finally(() => {
                                        this.loading = false;
                                         this.modalCount = true;
                                    })
                                    .catch(error => {
                                        alert('Произошла ошибка, обратитесь в службу тех.поддержки');
                                    })
                            });


                    }
                    /* ОПЛАТА КАРТОЙ */
                    if(noerror && type === 'card') {
                        const url = server_addr + "/proxy_/billing/v1/bills";
                        const ecom = server_addr + "/proxy_/wcecom/v1/CreateOrder";
                        const redirectUrl = window.location.href;

                        this.$http
                            .post(url, {
                                "paymentMethod": "CARD",
                                "items": postPayment
                            })
                            .then(response => {
                                this.currentCount = response.data.billId;

                                this.$http
                                    .post(ecom, {
                                        "billId": this.currentCount,
                                        "redirectUrl": redirectUrl,
                                    })
                                    .then(response => {
                                        this.ecom.orderId = response.data.orderId;
                                        //this.ecom.sessionId = response.data.sessionId;
                                        // this.ecom.status = response.data.status;
                                        this.ecom.url = response.data.url;
                                        this.ecom.password = response.data.password;
                                        this.modalCard = true;
                                    })

                            })
                            .finally(() => {
                            });
                    }

                    /* ОПЛАТА ЧЕРЕЗ QIWI */
                    if(noerror && type === 'qiwi') {
                        const url = server_addr + "/proxy_/billing/v1/bills";
                        this.$http
                            .post(url, {
                                "paymentMethod": "QIWI",
                                "items": postPayment
                            })
                            .then(response => {
                                this.currentCount = response.data.billId;
                            })
                            .finally(() => {
                                this.modalQiwi = true;
                            });

                    }
                }
            },

            paymentByCard (url, order, password) {
                // window.location.href = url + '?OrderID=' + order + '&SessionID=' + session;
                //window.open(url + '?id=' + order + '&password=' + password);
                window.onbeforeunload = function() {
                    return "Вы уверены, что хотите покинуть эту страницу? Все несохраненные данные будут потеряны.";
                }

                window.location.href = url + '?id=' + order + '&password=' + password;
                // this.$http
                //     .post(url, {
                //         "orderId": order,
                //         "sessionId": session,
                //     })
                //     .then(response => {
                //         // this.modalCard = true;
                //     })
            }

        },
        mounted: function () {
            this.getPageParams();
            this.fetchData();
            this.getTariffs();
        }
    };


</script>

<style scoped>
  .text-center {
    text-align: center;
  }

  .body-row {
    padding: 0 15px;
    position: relative;
  }

  .title-box {
    display: none;
  }

  .checkAllMobile {
    display: none;
    margin-bottom: 20px;
  }

  @media (max-width: 991px) {
    .header-row {
      display: none;
    }

    .checkAllMobile {
      display: block;
    }

    .body-row {
      padding: 20px 15px;
    }

    .text-center {
      text-align: left;
    }

    .title {
      font-weight: bold;
      font-size: 16px;
    }

    .main-info {
      margin-bottom: 2px;
      font-size: 9px;
      color: #6D82A3;
    }
    .title-box {
      display: inline-block;
    }

    .select-box {
      padding: 20px 0;
    }

    .text-right {
      text-align: left;
    }

    .input-box {
      position: absolute;
      right: 15px;
      top: 20px;
      z-index: 3;
      text-align: right;
    }
  }

  @media (max-width: 767px) {
    .select-box {
      text-align: center;
    }

    .text-right {
      text-align: center;
    }

    .mb-50 {
      margin-bottom: 20px;
    }
  }
</style>

<style>


  .ivu-notice .ivu-notice-desc {
    text-align: left;
    font-size: 16px;
  }

  .ivu-notice .ivu-notice-title {
    text-align: left;
    font-size: 16px;
  }

  .ivu-notice {
    width: 330px;
  }

  @media (min-width: 768px) {
    .ivu-col-span-md-0 {
      display: block;
      width: auto;
    }
  }

  @media (min-width: 576px) {
    .ivu-col-span-sm-0 {
      display: block;
      width: auto;
    }
  }



</style>



// WEBPACK FOOTER //
// src/apps/payment/payment.vue